import { LogoGithub } from '@carbon/icons-react';
import { Article } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet';
import { My } from '../../../data/My';
import BackToTop from '../../BackToTop';
import Footer from '../../Footer';
import Hero from '../../Hero';

const AboutScreen = () => {
    return (
        <>
            <Helmet>
                <title>{My.name}</title>
                <meta
                    name="title"
                    content="Yulian Kraynyak"
                    data-react-helmet="true"
                />
                <meta
                    name="description"
                    content="I'm Yulian Kraynyak, a Machine Learning Engineer based in NYC."
                    data-react-helmet="true"
                />
                <meta
                    property="og:image"
                    content="../../public/resources/meta-image.jpg"
                    data-react-helmet="true"
                />
            </Helmet>

            <Hero
                header={
                    <>
                        <h1>
                            I'm <strong>Yulian,</strong><br/> a{' '}
                            <strong>
                                <em>software engineer</em>
                            </strong>{' '}
                            at <strong>Amazon</strong>
                        </h1>
                    </>
                }
                body={<></>}
            />

            <p>
                Based in <strong>Brooklyn, NY</strong> with an{' '}
                <strong>MS CS</strong> from <strong>NYU.</strong> I like to <strong>code,</strong> {' '}
                <strong>draw</strong> and{' '}
                <strong>synthesize</strong> noises.
            </p>

            <Stack
                direction="row"
                spacing={2}
                style={{ marginTop: 60, marginBottom: 35 }}
                sx={{ justifyContent: 'stretch' }}
            >
                <Button
                    aria-label="resume button"
                    href={My.resume}
                    target="_blank"
                    startIcon={<Article />}
                >
                    Resume
                </Button>
                <Button
                    aria-label="portfolio button"
                    href={My.portfolio}
                    target="_blank"
                    startIcon={<LogoGithub />}
                >
                    Portfolio
                </Button>
            </Stack>

            <Footer />
            <BackToTop />
        </>
    );
};

export default AboutScreen;
